<template>
	<svg
		width="16"
		:class="classes"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_3289_32400)">
			<path
				d="M5.72656 5.44L8.7799 8.5L5.72656 11.56L6.66656 12.5L10.6666 8.5L6.66656 4.5L5.72656 5.44Z"
				:fill="color"
			/>
		</g>
        
		<defs>
			<clipPath id="clip0_3289_32400">
				<rect
					width="16"
					height="16"
					fill="white"
					transform="translate(0 16.5) rotate(-90)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

<script setup>
const props = defineProps({
	color: {
		type: String,
		default: '#8897AA'
	},
	classes: {
		type: String,
		default: ''
	},
});
</script>